import React, { PureComponent } from 'react';
import i18next from 'i18next';
import { arrayOf, string, func } from 'prop-types';

import { subsidiaryPropTypes } from '~propTypes/subsidiary';
import { addressPropTypes } from '~propTypes/address';
import storePropTypes from '~constants/propTypes';
import { DISPATCH_METHODS } from '~constants/address';
import { normalizeCoordinates } from '~utils/maps';

import Store from './components/Store';
import styles from './styles.module.scss';
import { getStoreKey, storesKeyMatch } from './utils';

class PickUp extends PureComponent {
  state = {
    hoveredStore: null,
    location: this.props.selectedAddress ? normalizeCoordinates(this.props.selectedAddress) : null
  };

  handleConfirm = () => {
    const { onConfirm, selectedStore } = this.props;

    onConfirm({
      store: selectedStore,
      type: DISPATCH_METHODS.PICKUP
    });
  };

  handleStoreSelect = (store) => {
    const { onStoreSelect } = this.props;
    onStoreSelect({ store });
  };

  handleStoreFocus = (obj) => {
    const { onStoreFocus } = this.props;
    const { hoveredStore } = this.state;
    const store = obj?.store || obj;
    if (!storesKeyMatch(hoveredStore, store)) {
      this.setState({ hoveredStore: store });
      onStoreFocus?.(store);
    }
  };

  handleStoreBlur = () => {
    const { onStoreBlur } = this.props;

    this.setState({ hoveredStore: null });
    onStoreBlur?.();
  };

  render() {
    const { stores, selectedStore, className } = this.props;
    const { hoveredStore, location } = this.state;
    const focusedStore = hoveredStore || selectedStore;
    return (
      <>
        <div className={`row full-width m-bottom-2 ${styles.pickUp} ${className}`}>
          <div className={`column item-1 full-width ${styles.cardContainer}`}>
            {stores.map((store, index) => (
              <Store
                key={getStoreKey(store)}
                store={store}
                order={index + 1}
                location={location}
                focused={storesKeyMatch(focusedStore, store)}
                onSelect={this.handleStoreSelect}
                onMouseLeave={this.handleStoreBlur}
                onMouseEnter={this.handleStoreFocus}
              />
            ))}
          </div>
        </div>
        {selectedStore && (
          <button
            type="submit"
            className={`button primary full-width ${styles.confirmButton}`}
            onClick={this.handleConfirm}>
            {i18next.t('Delivery:confirmButton')}
          </button>
        )}
      </>
    );
  }
}

PickUp.propTypes = {
  onConfirm: func.isRequired,
  onStoreSelect: func.isRequired,
  className: string,
  selectedAddress: addressPropTypes,
  selectedStore: storePropTypes,
  stores: arrayOf(subsidiaryPropTypes),
  onStoreBlur: func,
  onStoreFocus: func
};

export default PickUp;
